export default __webpack_public_path__ + "static/media/wireframe3.dbcb4977.png";